import Modal from "react-bootstrap/Modal";
import TimesheetPdfEditor from "../components/TimesheetPdfEditor";

const PdfViewerModal = ({ visible, close, shift }) => {
  if (shift === null || shift === undefined) return;

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Timesheet {shift?.timesheet?.filename}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TimesheetPdfEditor
          shift={shift}
          onComplete={(s) => {
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default PdfViewerModal;
